import { LoaderCircle } from "lucide-react";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";

type SpinnerProps = ComponentProps<typeof LoaderCircle> & {
  decorative?: boolean;
  label?: string;
};

export function Spinner({
  className,
  decorative = false,
  label = "Loading",
  ...props
}: SpinnerProps) {
  return (
    <LoaderCircle
      role={decorative ? undefined : "status"}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}
